<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">柱状图</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
        <div class="block">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd hh:mm:ss"
            value-format="yyyy-MM-dd hh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="clickBtn()">查询</el-button>
        </div>
      </div>
      <div ref="modularChild11" class="echarts"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as echarts from "echarts"
export default {
  name: 'modularChild11',
  props: ['socUserName'],
  data() {
    return {
      value1: '',
      value2: [],
      radio: 1,
      chartsi: null,
      chartLoading: false,
      optioni: {
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        tooltip: {
          trigger: 'axis',
        },
        series: [
          {
            data: [],
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              // color: "rgba(220, 220, 220, 0.8)"
            }
          }
        ]
      },
      endTime: "",
      username: "",
      startTime: ""   
    };
  },
  methods: {
    timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
        var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';
        var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
        var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
        var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
        var timestamp = Y+M+D+h+m+s;
        return timestamp;
    },
    getTime(socUserName){
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var startTime = nowdate.setMonth(nowdate.getMonth()-1); 
      var endTime = Date.parse(new Date());
      this.timestampToTime(startTime);
      this.timestampToTime(endTime);          
      startTime = this.timestampToTime(startTime);
      endTime = this.timestampToTime(endTime);
      let params = {
        "limit": 10000,
        "offset": 0,        
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }     
      this.getData(params)
    },
    clickBtn(socUserName) {     
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        "limit": 10000,
        "offset": 0,          
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }    
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/querySecurityIncidentTrend`, params)
        .then(data => {          
          if (data && data.status === 200 && data.data.code === 0) {
            let res = this.formatterData(data.data.data)
            this.chartsi.setOption(this.optioni)
            this.dataList = res
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
      // this.chartsi.setOption(this.optioni)
    },
    formatterData(data) {
      this.optioni.xAxis.data = []
      this.optioni.series[0].data = []
      if (data.xAxis && data.xAxis.length) {
        this.optioni.xAxis.data = data.xAxis
      }
      if (data.yAxis && data.yAxis.length) {
        this.optioni.series[0].data = data.yAxis
      }
      return this.optioni
    }
  },
  mounted() {
    let charti = echarts.getInstanceByDom(this.$refs["modularChild11"]);
    if (charti === undefined) {
      this.chartsi = echarts.init(this.$refs["modularChild11"]);
      this.$once("hook:beforeDestroy", function() {
        echarts.dispose(this.chartsi);
      });
    }
    this.getTime();
  }
};
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
}
</style>